import {
  Component,
  OnInit,
} from "@angular/core";

import {
  ToastrService,
} from "ngx-toastr";

import {
  finalize,
} from "rxjs/operators";

import {
  ServiceAvailabilityDTO,
  ServiceAvailabilityReadAllPaginatedRequestDTO,
  ServiceAvailabilityUpdateRequestDTO,
} from "../service-availability-interface";

import {
  ServiceAvailabilityService,
} from "../service-availability.service";


@Component({
  selector: "app-service-availability",

  templateUrl:
    "./service-availabilty.component.html",

  styleUrls: [
    "./service-availabilty.component.css",
  ],
})
export class ServiceAvailabilityComponent
  implements OnInit {

  // ============================================================
  // LIST
  // ============================================================

  serviceList: ServiceAvailabilityDTO[] = [];

  filteredServiceList: ServiceAvailabilityDTO[] = [];


  // ============================================================
  // SEARCH
  // ============================================================

  searchText: string = "";


  // ============================================================
  // LOADING
  // ============================================================

  isLoading: boolean = false;


  // ============================================================
  // PAGINATION
  // ============================================================

  pageNo: number = 1;

  pageSize: number = 10;

  totalCount: number = 0;

  totalPages: number = 1;


  pageSizeOptions: number[] = [
    10,
    20,
    50,
    100,
  ];


  constructor(
    private serviceAvailabilityService:
      ServiceAvailabilityService,

    private toastr:
      ToastrService,
  ) {}


  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    this.loadServiceAvailability();

  }


  // ============================================================
  // READ ALL PAGINATED
  //
  // ONLY API USED FOR LIST:
  //
  // POST /M/SA/ReadAllPaginated
  // ============================================================

  loadServiceAvailability(): void {

    if (this.isLoading) {
      return;
    }


    /*
     * Always ensure PageNo / PageSize
     * are greater than zero.
     *
     * This prevents SQL FETCH 0 error.
     */
    const safePageNo =
      Number(this.pageNo) > 0
        ? Number(this.pageNo)
        : 1;


    const safePageSize =
      Number(this.pageSize) > 0
        ? Number(this.pageSize)
        : 10;


    this.pageNo =
      safePageNo;


    this.pageSize =
      safePageSize;


    const request:
      ServiceAvailabilityReadAllPaginatedRequestDTO = {

      pageNo:
        safePageNo,

      pageSize:
        safePageSize,

      whereClause:
        "",

      orderByClause:
        "",

    };


    console.log(
      "ServiceAvailability ReadAllPaginated Request:",
      request,
    );


    this.isLoading = true;


    this.serviceAvailabilityService
      .readAllPaginated(
        request,
      )
      .pipe(
        finalize(() => {

          this.isLoading = false;

        }),
      )
      .subscribe({

        next: (
          response: any,
        ) => {

          console.log(
            "ServiceAvailability ReadAllPaginated Response:",
            response,
          );


          /*
           * Normal Nishwik response:
           *
           * {
           *   items: [...]
           * }
           */
          const items: any[] =
            response?.items ??
            response?.Items ??
            response?.data?.items ??
            response?.Data?.items ??
            response?.data ??
            response?.Data ??
            [];


          this.serviceList =
            Array.isArray(items)
              ?
              items.map(
                (
                  item: any,
                  index: number,
                ): ServiceAvailabilityDTO => {

                  return {

                    id:
                      Number(
                        item?.id ??
                        item?.Id ??
                        0,
                      ),

                    serviceKey:
                      String(
                        item?.serviceKey ??
                        item?.ServiceKey ??
                        "",
                      ),

                    /*
                     * Backend:
                     *
                     * public int? RoleId { get; set; }
                     *
                     * Therefore:
                     * number -> number
                     * null   -> null
                     */
                    roleId:
                      this.normalizeNullableNumber(
                        item?.roleId ??
                        item?.RoleId ??
                        null,
                      ),

                    isEnabled:
                      this.toBoolean(
                        item?.isEnabled ??
                        item?.IsEnabled ??
                        false,
                      ),

                    /*
                     * Backend:
                     *
                     * public string? MaintenanceMessage
                     *
                     * Keep null as null.
                     */
                    maintenanceMessage:
                      this.normalizeNullableString(
                        item?.maintenanceMessage ??
                        item?.MaintenanceMessage ??
                        null,
                      ),

                    /*
                     * Backend:
                     *
                     * public DateTime? MaintenanceStartUtc
                     *
                     * Keep null as null.
                     */
                    maintenanceStartUtc:
                      this.normalizeNullableUtcDate(
                        item?.maintenanceStartUtc ??
                        item?.MaintenanceStartUtc ??
                        null,
                      ),

                    /*
                     * Backend:
                     *
                     * public DateTime? MaintenanceEndUtc
                     *
                     * Keep null as null.
                     */
                    maintenanceEndUtc:
                      this.normalizeNullableUtcDate(
                        item?.maintenanceEndUtc ??
                        item?.MaintenanceEndUtc ??
                        null,
                      ),

                    createdBy:
                      item?.createdBy ??
                      item?.CreatedBy ??
                      null,

                    createdOn:
                      item?.createdOn ??
                      item?.CreatedOn ??
                      null,

                    modifiedBy:
                      item?.modifiedBy ??
                      item?.ModifiedBy ??
                      null,

                    modifiedOn:
                      item?.modifiedOn ??
                      item?.ModifiedOn ??
                      null,

                    isActive:
                      this.toBoolean(
                        item?.isActive ??
                        item?.IsActive ??
                        false,
                      ),

                    isDeleted:
                      this.toBoolean(
                        item?.isDeleted ??
                        item?.IsDeleted ??
                        false,
                      ),

                    rowNum:
                      Number(
                        item?.rowNum ??
                        item?.RowNum ??
                        (
                          (
                            this.pageNo - 1
                          ) *
                          this.pageSize
                        ) +
                        index +
                        1,
                      ),

                    totalCount:
                      Number(
                        item?.totalCount ??
                        item?.TotalCount ??
                        0,
                      ),

                    totalRecords:
                      Number(
                        item?.totalRecords ??
                        item?.TotalRecords ??
                        0,
                      ),

                    isUpdating:
                      false,

                  };

                },
              )
              :
              [];


          // ====================================================
          // TOTAL COUNT
          // ====================================================

          if (
            this.serviceList.length > 0
          ) {

            this.totalCount =
              Number(
                this.serviceList[0]
                  ?.totalCount ??
                this.serviceList[0]
                  ?.totalRecords ??
                response?.totalCount ??
                response?.TotalCount ??
                this.serviceList.length,
              );

          }
          else {

            this.totalCount = 0;

          }


          this.totalPages =
            Math.max(
              1,
              Math.ceil(
                this.totalCount /
                this.pageSize,
              ),
            );


          this.applyFilter();

        },


        error: (
          error: any,
        ) => {

          console.error(
            "ServiceAvailability ReadAllPaginated Error:",
            error,
          );


          this.serviceList = [];

          this.filteredServiceList = [];

          this.totalCount = 0;

          this.totalPages = 1;


          this.toastr.error(
            error?.error?.message ??
            error?.error?.Message ??
            "Unable to load service availability.",
          );

        },

      });

  }


  // ============================================================
  // TOGGLE
  //
  // ONLY API USED:
  //
  // POST /M/SA/Update
  //
  //
  // ON:
  // IsEnabled = 1 / true
  //
  // OFF:
  // IsEnabled = 0 / false
  //
  //
  // IsActive = UNCHANGED
  // IsDeleted = UNCHANGED
  // ============================================================

  onToggleService(
    item: ServiceAvailabilityDTO,
    event: Event,
  ): void {

    const input =
      event.target as HTMLInputElement;


    if (
      !input ||
      item.isUpdating
    ) {

      return;

    }


    const checked =
      input.checked;


    const oldIsEnabled =
      item.isEnabled;


    /*
     * ==========================================================
     * BACKEND DTO:
     *
     * public int Id
     * public string ServiceKey
     * public int? RoleId
     * public bool IsEnabled
     * public string? MaintenanceMessage
     * public DateTime? MaintenanceStartUtc
     * public DateTime? MaintenanceEndUtc
     * public string ModifiedBy
     *
     *
     * IMPORTANT:
     *
     * Nullable backend properties MUST remain null
     * when no value exists.
     *
     * DO NOT send:
     *
     * RoleId = 0
     * MaintenanceMessage = ""
     * MaintenanceStartUtc = ""
     * MaintenanceEndUtc = ""
     *
     * Correct representation is:
     *
     * RoleId = null
     * MaintenanceMessage = null
     * MaintenanceStartUtc = null
     * MaintenanceEndUtc = null
     *
     * Only IsEnabled is changed by this toggle.
     * ==========================================================
     */
    const request:
      ServiceAvailabilityUpdateRequestDTO = {

      id:
        Number(
          item.id,
        ),

      serviceKey:
        String(
          item.serviceKey || "",
        )
          .trim(),

      roleId:
        this.normalizeNullableNumber(
          item.roleId,
        ),

      isEnabled:
        Boolean(
          checked,
        ),

      maintenanceMessage:
        this.normalizeNullableString(
          item.maintenanceMessage,
        ),

      maintenanceStartUtc:
        this.normalizeNullableUtcDate(
          item.maintenanceStartUtc,
        ),

      maintenanceEndUtc:
        this.normalizeNullableUtcDate(
          item.maintenanceEndUtc,
        ),

      modifiedBy:
        this.getCurrentUserName(),

    };


    console.log(
      "==========================================",
    );

    console.log(
      "ServiceAvailability Update Request Object:",
      request,
    );


    /*
     * JSON payload exactly as sent to backend.
     */
    console.log(
      "ServiceAvailability Update Request JSON:",
      JSON.stringify(
        request,
      ),
    );

    console.log(
      "==========================================",
    );


    item.isUpdating = true;


    this.serviceAvailabilityService
      .update(
        request,
      )
      .pipe(
        finalize(() => {

          item.isUpdating = false;

        }),
      )
      .subscribe({

        next: (
          response: any,
        ) => {

          console.log(
            "ServiceAvailability Update Response:",
            response,
          );


          /*
           * HTTP success means update succeeded.
           *
           * Update ONLY IsEnabled locally.
           *
           * RoleId,
           * MaintenanceMessage,
           * MaintenanceStartUtc,
           * MaintenanceEndUtc,
           * IsActive,
           * IsDeleted
           *
           * are untouched.
           */
          item.isEnabled =
            checked;


          this.toastr.success(
            checked
              ?
              `${this.getServiceDisplayName(
                item.serviceKey,
              )} enabled successfully.`
              :
              `${this.getServiceDisplayName(
                item.serviceKey,
              )} disabled successfully.`,
          );


          this.applyFilter();

        },


        error: (
          error: any,
        ) => {

          console.error(
            "ServiceAvailability Update Error:",
            error,
          );


          console.error(
            "ServiceAvailability Update Error Response:",
            error?.error,
          );


          /*
           * Revert only toggle value.
           */
          item.isEnabled =
            oldIsEnabled;


          input.checked =
            oldIsEnabled;


          this.toastr.error(
            error?.error?.message ??
            error?.error?.Message ??
            "Unable to update service availability.",
          );

        },

      });

  }


  // ============================================================
  // STATUS
  //
  // Existing HTML already uses this function name.
  //
  // Status is controlled by IsEnabled only.
  // ============================================================

  isServiceActive(
    item: ServiceAvailabilityDTO,
  ): boolean {

    return this.toBoolean(
      item.isEnabled,
    );

  }


  // ============================================================
  // SEARCH
  // ============================================================

  onSearchChange(): void {

    this.applyFilter();

  }


  clearSearch(): void {

    this.searchText = "";

    this.applyFilter();

  }


  private applyFilter(): void {

    const search =
      String(
        this.searchText || "",
      )
        .trim()
        .toLowerCase();


    if (!search) {

      this.filteredServiceList = [
        ...this.serviceList,
      ];

      return;

    }


    this.filteredServiceList =
      this.serviceList.filter(
        (
          item:
            ServiceAvailabilityDTO,
        ) => {

          const serviceKey =
            String(
              item.serviceKey || "",
            )
              .toLowerCase();


          const serviceName =
            this
              .getServiceDisplayName(
                item.serviceKey,
              )
              .toLowerCase();


          const category =
            this
              .getServiceCategory(
                item.serviceKey,
              )
              .toLowerCase();


          return (
            serviceKey.includes(
              search,
            ) ||
            serviceName.includes(
              search,
            ) ||
            category.includes(
              search,
            )
          );

        },
      );

  }


  // ============================================================
  // PAGINATION
  // ============================================================

  previousPage(): void {

    if (
      this.pageNo <= 1 ||
      this.isLoading
    ) {

      return;

    }


    this.pageNo--;


    this.loadServiceAvailability();

  }


  nextPage(): void {

    if (
      this.pageNo >=
        this.totalPages ||
      this.isLoading
    ) {

      return;

    }


    this.pageNo++;


    this.loadServiceAvailability();

  }


  goToPage(
    page: number,
  ): void {

    if (
      page < 1 ||
      page > this.totalPages ||
      page === this.pageNo ||
      this.isLoading
    ) {

      return;

    }


    this.pageNo =
      page;


    this.loadServiceAvailability();

  }


  onPageSizeChange(
    event: Event,
  ): void {

    const select =
      event.target as HTMLSelectElement;


    if (!select) {
      return;
    }


    const newPageSize =
      Number(
        select.value,
      );


    if (
      newPageSize <= 0
    ) {

      return;

    }


    this.pageSize =
      newPageSize;


    this.pageNo =
      1;


    this.loadServiceAvailability();

  }


  // ============================================================
  // PAGE NUMBERS
  // ============================================================

  get pageNumbers(): number[] {

    const pages: number[] = [];


    let startPage =
      Math.max(
        1,
        this.pageNo - 2,
      );


    let endPage =
      Math.min(
        this.totalPages,
        startPage + 4,
      );


    startPage =
      Math.max(
        1,
        endPage - 4,
      );


    for (
      let page = startPage;
      page <= endPage;
      page++
    ) {

      pages.push(
        page,
      );

    }


    return pages;

  }


  // ============================================================
  // COUNTS
  // ============================================================

  get activeServiceCount(): number {

    return this.serviceList.filter(
      (
        item:
          ServiceAvailabilityDTO,
      ) =>
        this.isServiceActive(
          item,
        ),
    ).length;

  }


  get inactiveServiceCount(): number {

    return this.serviceList.filter(
      (
        item:
          ServiceAvailabilityDTO,
      ) =>
        !this.isServiceActive(
          item,
        ),
    ).length;

  }


  // ============================================================
  // SERVICE DISPLAY NAME
  // ============================================================

  getServiceDisplayName(
    serviceKey:
      string |
      null |
      undefined,
  ): string {

    if (!serviceKey) {

      return "-";

    }


    return serviceKey
      .replace(
        /_/g,
        " ",
      )
      .replace(
        /\s+/g,
        " ",
      )
      .trim()
      .toLowerCase()
      .replace(
        /\b\w/g,
        (
          char:
            string,
        ) =>
          char.toUpperCase(),
      );

  }


  // ============================================================
  // CATEGORY
  // ============================================================

  getServiceCategory(
    serviceKey:
      string |
      null |
      undefined,
  ): string {

    const key =
      String(
        serviceKey || "",
      )
        .toUpperCase();


    if (
      key.startsWith("BBPS")
    ) {

      return "BBPS";

    }


    if (
      key.startsWith("INVEST")
    ) {

      return "Investment";

    }


    if (
      key.startsWith("SCHOOL")
    ) {

      return "School";

    }


    if (
      key.startsWith("HOSPITAL")
    ) {

      return "Hospital";

    }


    if (
      key.startsWith("SOCIETY") ||
      key.startsWith("HOUSING")
    ) {

      return "Housing Society";

    }


    return "Common";

  }


  // ============================================================
  // TRACK BY
  // ============================================================

  trackByServiceId(
    index: number,
    item: ServiceAvailabilityDTO,
  ): number {

    return item.id;

  }


  // ============================================================
  // REFRESH
  // ============================================================

  refresh(): void {

    this.loadServiceAvailability();

  }


  // ============================================================
  // BOOLEAN
  // ============================================================

  private toBoolean(
    value: any,
  ): boolean {

    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      String(value)
        .trim()
        .toLowerCase() === "true"
    );

  }


  // ============================================================
  // NORMALIZE NULLABLE NUMBER
  //
  // Backend:
  //
  // public int? RoleId { get; set; }
  //
  // Examples:
  //
  // null      -> null
  // undefined -> null
  // ""        -> null
  // "22"      -> 22
  // 22        -> 22
  // ============================================================

  private normalizeNullableNumber(
    value: any,
  ): number | null {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {

      return null;

    }


    const numberValue =
      Number(
        value,
      );


    if (
      Number.isNaN(
        numberValue,
      )
    ) {

      return null;

    }


    return numberValue;

  }


  // ============================================================
  // NORMALIZE NULLABLE STRING
  //
  // Backend:
  //
  // public string? MaintenanceMessage { get; set; }
  //
  // null / undefined / empty -> null
  // otherwise string value
  // ============================================================

  private normalizeNullableString(
    value:
      string |
      null |
      undefined,
  ): string | null {

    if (
      value === null ||
      value === undefined
    ) {

      return null;

    }


    const stringValue =
      String(
        value,
      )
        .trim();


    if (
      stringValue.length === 0
    ) {

      return null;

    }


    return stringValue;

  }


  // ============================================================
  // NORMALIZE NULLABLE UTC DATE
  //
  // Backend:
  //
  // public DateTime? MaintenanceStartUtc
  // public DateTime? MaintenanceEndUtc
  //
  // null / undefined / empty -> null
  //
  // valid date -> ISO UTC string
  //
  // This guarantees Angular sends a format which
  // ASP.NET DateTime? can deserialize safely.
  // ============================================================

  private normalizeNullableUtcDate(
    value:
      string |
      null |
      undefined,
  ): string | null {

    if (
      value === null ||
      value === undefined
    ) {

      return null;

    }


    const stringValue =
      String(
        value,
      )
        .trim();


    if (
      stringValue.length === 0
    ) {

      return null;

    }


    const date =
      new Date(
        stringValue,
      );


    if (
      Number.isNaN(
        date.getTime(),
      )
    ) {

      console.warn(
        "Invalid maintenance UTC date received:",
        value,
      );


      return null;

    }


    return date.toISOString();

  }


  // ============================================================
  // CURRENT USER
  // ============================================================

  private getCurrentUserName(): string {

    const userName =
      localStorage.getItem(
        "userName",
      ) ||
      localStorage.getItem(
        "username",
      ) ||
      localStorage.getItem(
        "UserName",
      ) ||
      "system";


    return String(
      userName,
    )
      .trim() || "system";

  }

}


/*
 * KEEP:
 * Your routing currently has the misspelled class name.
 */
export {
  ServiceAvailabilityComponent
    as ServiceAvailabiltyComponent,
};